import React from "react";
import { getImage } from "../../../../../../utils/getImages";
import "./app.css";
const BlogThumbnailPreview = ({ cardData, activetab }) => {
  return (
    <div>
      <div className="card-body" style={{margin:"20px"}}></div>
      <div className="destination-package" style={{ width: "200px",margin:"20px" }}>
        <img
          alt=""
          src={getImage(
            activetab === "simplified_chinese" ? cardData?.simplified_chinese_image
              : activetab === "treditonal_chinese" ? cardData?.traditional_chinese_image
              : activetab === "bahasa" ? cardData?.bahasa_image
              : cardData?.image
          )}
          className="w-100 rounded"
        />

        
          <div>
            <div >
              <p  data-lang='{ "CN":"皇宫庭苑别墅" }'>
              {activetab === "simplified_chinese"
                  ? cardData?.simplified_chinese_title
                  : activetab === "treditonal_chinese"
                  ? cardData?.traditional_chinese_title
                  : activetab === "bahasa"
                  ? cardData?.bahasa_title
                  : cardData?.title}
              </p>
              <div
          style={{
            direction: activetab === "arabic" && "rtl",
            fontSize: "10px",
            fontWeight: "400",
            marginTop: 5,
          }}
          dangerouslySetInnerHTML={{
            __html:
              activetab === "simplified_chinese"
                ? cardData?.simplified_chinese_description
                : activetab === "treditonal_chinese"
                ? cardData?.traditional_chinese_description
                : activetab === "bahasa"
                ? cardData?.bahasa_description
                : cardData?.description,
          }}
        />
            </div>

          </div>
     
      </div>
    </div>
  );
};

export default BlogThumbnailPreview;
